import { render, staticRenderFns } from "./CPanelDomainModal.vue?vue&type=template&id=39dc55f4&"
import script from "./CPanelDomainModal.vue?vue&type=script&lang=js&"
export * from "./CPanelDomainModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports